// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checks-basket[data-v-222828ee]{min-height:74px;position:relative}.checks-basket-container[data-v-222828ee]{bottom:0;position:absolute;right:0;z-index:2}.checks-basket .v-card[data-v-222828ee]{min-width:400px}.card-header[data-v-222828ee]{background-color:var(--v-primary-base)}.card-footer[data-v-222828ee]{box-shadow:0 -10px 20px -20px rgba(0,0,0,.45)}.scroll-content[data-v-222828ee]{height:200px;overflow-x:hidden;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
